import { TextField } from "@mui/material";
import React from "react";
import styles from "./TextInput.module.scss";

export interface TextInputProps {
  label?: string;
  value?: unknown;
  onChange?:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  multiline?: boolean | undefined;
  rows?: number | undefined;
  placeholder?: string | undefined;
  error?: boolean;
  style?: React.CSSProperties | undefined;
  type?: React.HTMLInputTypeAttribute;
  variant?: "dark" | "light";
}
export default function TextInput({
  label,
  value,
  onChange,
  multiline,
  rows,
  placeholder,
  error,
  style,
  type,
  variant,
}: TextInputProps) {
  if (variant === "dark") {
    return (
      <TextInputMJB
        style={style}
        error={error}
        label={label}
        multiline={multiline}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
      />
    );
  }

  const hasValue =
    value !== undefined && value !== null && value !== "" && !Number.isNaN(value);

  return (
    <>
      <TextField
        style={style}
        error={error}
        id="outlined-multiline"
        label={label}
        multiline={multiline}
        rows={rows}
        fullWidth
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        InputLabelProps={{ shrink: hasValue || Boolean(placeholder) }}
      />
    </>
  );
}

const TextInputMJB = ({ label, value, onChange, type, error}: TextInputProps) => {

  const errorLabel = error ? 'error' : '';
  return (
    <div className={[styles["input"],styles["input--"+errorLabel ] ].join(" ")}>
      <span className={[styles["input__label"], styles["input__label--"+errorLabel ] ].join(" ")}>{label}</span>
      <div className={[styles["input__input-container"], styles["input__input-container--"+errorLabel]].join(" ")}>
        <input
          type={type}
          className={[styles["input__input-container__input-item"], styles["input__input-container__input-item--"+errorLabel]].join(" ")}
          value={value as string | number}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
